import {
    createContext,
    useContext,
    useEffect,
    useMemo,
    useState,
} from "react";
import { dict, DEFAULT_LANG, LANGS } from "./translations";

const I18nContext = createContext({
    lang: DEFAULT_LANG,
    setLang: () => {},
    t: dict[DEFAULT_LANG],
});

const STORAGE_KEY = "ftk-lang";

export function I18nProvider({ children }) {
    const [lang, setLang] = useState(() => {
        try {
            const stored = localStorage.getItem(STORAGE_KEY);
            if (stored && LANGS.includes(stored)) return stored;
        } catch (_) {}
        return DEFAULT_LANG;
    });

    useEffect(() => {
        try {
            localStorage.setItem(STORAGE_KEY, lang);
        } catch (_) {}
        document.documentElement.setAttribute("lang", lang);
    }, [lang]);

    const value = useMemo(
        () => ({ lang, setLang, t: dict[lang] || dict[DEFAULT_LANG] }),
        [lang],
    );

    return (
        <I18nContext.Provider value={value}>{children}</I18nContext.Provider>
    );
}

export function useI18n() {
    return useContext(I18nContext);
}
